import type { JSX } from 'preact';
import { T, Btn } from '../tokens';

interface PlaceholderProps {
  readonly name: string;
  readonly issueId?: string;
  readonly onBack?: () => void;
}

export function Placeholder({ name, issueId, onBack }: PlaceholderProps): JSX.Element {
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        padding: 40,
        textAlign: 'center',
        background: T.bg,
        color: T.ink3,
      }}
    >
      <div style={{ fontSize: 14 }}>
        экран не реализован: <code style={{ fontFamily: T.fontMono }}>{name}</code>
      </div>
      {issueId !== undefined ? (
        <div style={{ fontSize: 12, color: T.ink4, fontFamily: T.fontMono }}>{issueId}</div>
      ) : null}
      {onBack !== undefined ? (
        <Btn kind="ghost" onClick={onBack}>
          Назад
        </Btn>
      ) : null}
    </div>
  );
}
